enum PAYMENT_TYPE {
	AT_COUNTER = 'At counter',
	SEND_INVOICE = 'Send invoice',
	CREDIT_CARD = 'Credit Card',
	ADJUSTMENT = 'Adjustment',
}

export default PAYMENT_TYPE;
